import { useEffect } from "react";

const useViewportListener = () => {
  useEffect(() => {
    const setBaseFontSize = () => {
      const viewportWidth = document.documentElement.clientWidth;

      if (viewportWidth < 515) {
        const fontSize = (viewportWidth / 515) * 16;
        document.documentElement.style.fontSize = `${fontSize}px`;
      } else {
        document.documentElement.style.fontSize = "16px";
      }
    };

    setBaseFontSize();

    window.addEventListener("resize", setBaseFontSize);

    return () => window.removeEventListener("resize", setBaseFontSize);
  }, []);
};

export default useViewportListener;
